import EditFirmwareVersion from './EditFirmwareVersion';

export default EditFirmwareVersion;
